// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dialog-content[data-v-ab509eb8]{height:calc(100% - 60px);overflow:auto}.dialog-actions[data-v-ab509eb8]{position:sticky;bottom:0;background-color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
